// extracted by mini-css-extract-plugin
var _1 = "DashboardTileBadge-modulebadge__U_L4w IconNG-moduleiconContainer__SxWZ0";
var _2 = "DashboardTileBadge-moduleerror__D6emu";
var _3 = "DashboardTileBadge-moduleinfo__uFd3_";
var _4 = "DashboardTileBadge-modulepurple__XOQ_t";
var _5 = "DashboardTileBadge-modulesuccess__qoq_W";
var _6 = "DashboardTileBadge-modulewarning__ajNW_";
export { _1 as "badge", _2 as "error", _3 as "info", _4 as "purple", _5 as "success", _6 as "warning" }
